export default {
    getEquipmentStatuses: (state) => state.equipmentStatuses,
    getStatuses: (state) => state.statuses,
    getStatusesMap: (state) => state.statusesMap,
  }